module.exports = __webpack_public_path__ + "static/img/DVB4-CjM7gZe9.0a2ed5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/DVB4-CjM7gZe9.png
// module id = sXzT
// module chunks = 16